var render = function render(){
  var _vm$dashboard, _vm$dashboard2, _vm$dashboard3, _vm$dashboard3$info, _vm$dashboard4, _vm$dashboard4$info, _vm$dashboard5, _vm$dashboard5$info, _vm$dashboard6, _vm$dashboard6$info, _vm$dashboard7, _vm$dashboard7$info;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('p', [_vm._v("Buscar Por:")]), _c('v-row', {
    staticClass: "justify-start mt-3 ml-3"
  }, [_c('v-col', {
    attrs: {
      "cols": 6
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "GRE",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "return-object": "",
      "items": _vm.form.listaGerenciasRegionais
    },
    model: {
      value: _vm.form.filters.gre,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "gre", $$v);
      },
      expression: "form.filters.gre"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "btn-group"
  }, [_c('v-col', {
    staticClass: "text-end"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" Limpar ")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.buscarDashboardGre
    }
  }, [_vm._v(" Buscar ")])], 1)], 1)], 1), _vm.dashboard != null ? _c('div', {
    staticClass: "mt-7"
  }, [_c('StatusFormacao', {
    attrs: {
      "status-list": (_vm$dashboard = _vm.dashboard) === null || _vm$dashboard === void 0 ? void 0 : _vm$dashboard.statusFormacao,
      "data-hora-info": (_vm$dashboard2 = _vm.dashboard) === null || _vm$dashboard2 === void 0 ? void 0 : _vm$dashboard2.dataHoraInfo
    },
    on: {
      "visualizar-listagem": function ($event) {
        return _vm.openDialogListarStatusFormacao(null);
      }
    }
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center"
  }, [_c('div', {
    staticClass: "subtitle-2 mb-2 font-weight-medium"
  }, [_vm._v("Total De Formações")]), _c('div', {
    staticClass: "display-1 font-weight-bold blue--text mb-2"
  }, [_vm._v(_vm._s((_vm$dashboard3 = _vm.dashboard) === null || _vm$dashboard3 === void 0 ? void 0 : (_vm$dashboard3$info = _vm$dashboard3.info) === null || _vm$dashboard3$info === void 0 ? void 0 : _vm$dashboard3$info.totalFormacoes))]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "color": "blue"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogListarFormacoesGre();
      }
    }
  }, [_vm._v("Visualizar Listagem")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center"
  }, [_c('div', {
    staticClass: "subtitle-2 mb-2 font-weight-medium"
  }, [_vm._v("Participantes")]), _c('div', {
    staticClass: "display-1 font-weight-bold orange--text mb-2"
  }, [_vm._v(_vm._s((_vm$dashboard4 = _vm.dashboard) === null || _vm$dashboard4 === void 0 ? void 0 : (_vm$dashboard4$info = _vm$dashboard4.info) === null || _vm$dashboard4$info === void 0 ? void 0 : _vm$dashboard4$info.totalParticipantes))]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "color": "orange"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogListarParticipantesGre();
      }
    }
  }, [_vm._v("Visualizar Listagem")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center"
  }, [_c('div', {
    staticClass: "subtitle-2 mb-2 font-weight-medium"
  }, [_vm._v("Média De Frequência")]), _c('div', {
    staticClass: "display-1 font-weight-bold green--text mb-9"
  }, [_vm._v(_vm._s((_vm$dashboard5 = _vm.dashboard) === null || _vm$dashboard5 === void 0 ? void 0 : (_vm$dashboard5$info = _vm$dashboard5.info) === null || _vm$dashboard5$info === void 0 ? void 0 : _vm$dashboard5$info.mediaFrequencia) + "%")])])], 1)], 1), _c('v-row', {
    staticClass: "fill-height",
    staticStyle: {
      "height": "500px"
    }
  }, [_c('v-col', {
    staticClass: "fill-height",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center fill-height",
    staticStyle: {
      "height": "95%"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_vm._v("Formações")]), _c('PieChart', {
    attrs: {
      "chartData": _vm.dataPizza
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-row', {
    staticClass: "fill-height"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Presenças")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboard6 = _vm.dashboard) === null || _vm$dashboard6 === void 0 ? void 0 : (_vm$dashboard6$info = _vm$dashboard6.info) === null || _vm$dashboard6$info === void 0 ? void 0 : _vm$dashboard6$info.totalPresencas))]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-check-circle-outline")])], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Ausências")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboard7 = _vm.dashboard) === null || _vm$dashboard7 === void 0 ? void 0 : (_vm$dashboard7$info = _vm$dashboard7.info) === null || _vm$dashboard7$info === void 0 ? void 0 : _vm$dashboard7$info.totalAusencias))]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "red"
    }
  }, [_vm._v("mdi-clock-time-four-outline")])], 1)])], 1)], 1)], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "elevation": "2"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-space-between align-center mb-2"
  }, [_c('span', [_vm._v("Formações por GRE")]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.toggleSort
    }
  }, [_c('v-icon', [_vm._v("mdi-sort")])], 1)], 1), _c('HorizontalBarChart', {
    attrs: {
      "chartData": _vm.barChartData
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "btn-group"
  }, [_c('v-col', {
    staticClass: "text-end"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.exportarDadosPdf
    }
  }, [_vm._v(" Exportar Gráficos ")])], 1)], 1)], 1) : _vm._e(), _vm.dialogListarFormacaoStatusGre.visible ? _c('ListarFormacaoPorStatusGreDialog', {
    attrs: {
      "visible": _vm.dialogListarFormacaoStatusGre.visible,
      "content": _vm.dialogListarFormacaoStatusGre.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarFormacaoStatusGre.close();
      }
    }
  }) : _vm._e(), _vm.dialogListarFormacoesGre.visible ? _c('ListarFormacoesGreDialog', {
    attrs: {
      "visible": _vm.dialogListarFormacoesGre.visible,
      "content": _vm.dialogListarFormacoesGre.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarFormacoesGre.close();
      }
    }
  }) : _vm._e(), _vm.dialogListarParticipantesGre.visible ? _c('ListarParticipantesGreDialog', {
    attrs: {
      "visible": _vm.dialogListarParticipantesGre.visible,
      "content": _vm.dialogListarParticipantesGre.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarParticipantesGre.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }